










import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { getCookie, getStorage } from "@szgc/plt-core-v2";

@Component({
  name: "WbenProgressChart",
  components: {}
})
export default class WbenProgressChart extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  private processData: any = null;
  private imgUrl: any = "";
  private prefix: string = "";

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
      const token = getCookie("SZGC-SHIRO-TOKEN") || getStorage("SZGC-SHIRO-TOKEN") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      this.imgUrl = `${this.prefix}/api/appproc/packages/${this.processData.pacId}/flows/${
        this.processData.flowCfgId
      }/business/${
        this.processData.businessId
      }/tasks/image.png?_time=${new Date().getTime()}&SZGC-SHIRO-TOKEN=${token}`;
    }
  }

  /*打印*/
  print() {
    //判断iframe是否存在，删除之前的iframe
    let iframe: any = document.getElementById("wenbchPrintIframe");
    if (iframe) {
      document.body.removeChild(iframe);
    }
    const el: any = document.getElementById("wbenchPrintBox");
    iframe = document.createElement("IFRAME");
    iframe.setAttribute("id", "wenbchPrintIframe");
    iframe.setAttribute(
      "style",
      "position:absolute;width:0;height:0;overflow:hidden;left:-500px;top:-500px;"
    );
    document.body.appendChild(iframe);
    const doc: any = iframe.contentWindow.document;
    //这里可以自定义样式
    //doc.write("<LINK rel="stylesheet" type="text/css" href="css/print.css">");
    //去掉页眉页脚
    doc.write(`<style type="text/css">
      @page {
        size: auto;  /* auto is the initial value */
        margin: 0; /* this affects the margin in the printer settings */
      }
      </style>`);
    doc.write("<div style='text-align: center;font-size: 30px;'>流程模板图</div>");
    doc.write("<div>" + el.innerHTML + "</div>");
    doc.close();
    iframe.contentWindow.focus();
    setTimeout(() => {
      iframe.contentWindow.print();
    }, 500);
  }
}
